import { createSlice } from '@reduxjs/toolkit';
import { findPurchasePlan, getPurchasePlan } from './api';
import { initialState } from './api/interface';

const purchasePlanSlice = createSlice({
  name: 'purchasePlan',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPurchasePlan.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPurchasePlan.fulfilled, (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPurchasePlan.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });

    builder.addCase(getPurchasePlan.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPurchasePlan.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getPurchasePlan.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  purchasePlanSlice.actions;
export default purchasePlanSlice.reducer;
